import { render, staticRenderFns } from "./NewAppointmentSlots.vue?vue&type=template&id=9fb87e76"
import script from "./NewAppointmentSlots.vue?vue&type=script&lang=js"
export * from "./NewAppointmentSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports